<template>
    <li class="announcement flex-column flex-sm-row">
        <div>
            <a :href="permalink" class="h6 heading-link">{{ post_title }}</a>
            <div class="xsmall">{{ summary }}</div>
        </div>
        <img
            class="border-radius-sm ml-sm-3 mt-3 mt-sm-0 flex-grow-0 flex-shrink-0"
            :src="image.url"
            :alt="image.alt"
            v-if="image"
        />
    </li>
</template>

<script>
export default {
    name: 'item',
    props: ['ID', 'post_title', 'permalink', 'summary', 'image'],
};
</script>

<style lang="scss">
.announcement {
    display: flex;

    img {
        height: 8rem;
        width: 12rem;
        object-fit: cover;
        object-position: center top;
    }
}
</style>
